<template>
  <div id="app">
    <Header></Header>

    <Page>
      <div class="pb-8 px-content">
        <h2 class="subheadline">
          Stellenausschreibung
        </h2>
        <div class="flex justify-center">
          <h1 class="headline">Unsere offenen Stellen</h1>
        </div>

        <p>
          Du hast Lust in einem familiären Umfeld mit motivierten Kollegen an
          interessanten Stahl- und Metallbauarbeiten zu arbeiten? Dann bist Du
          bei uns genau richtig!
        </p>

        <p>
          Wir suchen aktuell Metallbauer (m/w/d) die unser Team verstärken. Alle
          Infos findest Du unter folgendem Link:
        </p>

        <a
          class="
            block
            text-center
            w-full
            shadow
            bg-brand-yellow
            border-brand-yellow
            hover:border-brand-blue
            border-2
            focus:shadow-outline focus:outline-none
            text-white
            font-bold
            py-2
            px-4
            rounded
            text-brand-blue
          "
          type="button"
          href="/stellenanzeige-metallbauer-kirchheim-teck.html"
          >Metallbauer (m/w/d) gesucht!</a
        >

        <p class="mb-12">
          Die passende Stelle für Dich ist nicht ausgeschrieben? Kein Problem,
          wir freuen uns über Deine Initiativbewerbung an
          <a class="link" href="mailto:info@schlosserei-raichle.de"
            >info@schlosserei-raichle.de</a
          >.
        </p>
      </div>

      <CallToAction></CallToAction>
    </Page>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import CallToAction from "../components/CallToAction.vue";
import Page from "../components/Page.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
  },
  data() {
    return {};
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/" + pic);
    },
  },
};
</script>

<style src="../assets/css/comfortaa.css"></style>
<style src="../assets/css/styles.css"></style>